// extracted by mini-css-extract-plugin
module.exports = {"promotion-reject-dialog":"promotion-reject-dialog-62750e55302cb39f0548d8a04da42675"};